import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { TopbarContainer } from '../../containers';
import {
  Page,
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  CausesPolicy,
  CausesPolicyEnglish, // Import the other component you want to conditionally render
  Footer,
} from '../../components';
import config from '../../config';

import css from './CausesPolicyPage.module.css';

const CausesPolicyPageComponent = props => {
  const { scrollingDisabled, intl } = props;
  const locale = intl.locale; // Extract the current locale

  const tabs = [
    {
      text: intl.formatMessage({ id: 'CausesPolicyPage.tosTabTitle' }),
      selected: false,
      linkProps: {
        name: 'TermsOfServicePage',
      },
    },
    {
      text: intl.formatMessage({ id: 'CausesPolicyPage.tsTabTitle' }),
      selected: false,
      linkProps: {
        name: 'ServicesFreePage',
      },
    },
    {
      text: intl.formatMessage({ id: 'CausesPolicyPage.pcTabTitle' }),
      selected: false,
      linkProps: {
        name: 'CancellationPolicyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'CausesPolicyPage.rpTabTitle' }),
      selected: false,
      linkProps: {
        name: 'RefundPolicyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'CausesPolicyPage.pcmTabTitle' }),
      selected: true,
      linkProps: {
        name: 'CausesPolicyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'CausesPolicyPage.usegTabTitle' }),
      selected: false,
      linkProps: {
        name: 'SeguroUupoPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'CausesPolicyPage.segypTabTitle' }),
      selected: false,
      linkProps: {
        name: 'SecurityPriorityPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'CommunicationSafetyPage.comunicationSafetyTabTitle' }),
      selected: false,
      linkProps: {
        name: 'CommunicationSafetyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'CausesPolicyPage.tpcdTabTitle' }),
      selected: false,
      linkProps: {
        name: 'TermProtectionPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'CausesPolicyPage.hipdTabTitle' }),
      selected: false,
      linkProps: {
        name: 'ProtectionDataPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'CausesPolicyPage.privacyTabTitle' }),
      selected: false,
      linkProps: {
        name: 'PrivacyPolicyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'CausesPolicyPage.pcookiesTabTitle' }),
      selected: false,
      linkProps: {
        name: 'CookiesPolicyPage',
      },
    },
  ];
  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'CausesPolicyPage.schemaTitle' }, { siteTitle });
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: schemaTitle,
  };

  return (
    <Page title={schemaTitle} scrollingDisabled={scrollingDisabled} schema={schema}>
      <LayoutSideNavigation>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="CausesPolicyPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperSideNav tabs={tabs} />
        <LayoutWrapperMain className={css.contentHeading}>
          <div className={css.content}>
            <h1 className={css.heading}>
              <FormattedMessage id="CausesPolicyPage.heading" />
            </h1>
            {locale === 'en-UK' ? <CausesPolicyEnglish /> : <CausesPolicy />}
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSideNavigation>
    </Page>
  );
};

const { bool } = PropTypes;

CausesPolicyPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const CausesPolicyPage = compose(connect(mapStateToProps), injectIntl)(CausesPolicyPageComponent);

export default CausesPolicyPage;
